import React from 'react';
import ReactDOM from 'react-dom/client';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
  <>
    <App />
  </>
);
